import React, { useEffect, useState } from 'react';
import { authAPI } from '../../services/api';

// Google's multi-colour "G" mark.
const GoogleIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 18 18" aria-hidden="true">
    <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z" />
    <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z" />
    <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
  </svg>
);

// "Continue with Google" button. Renders only when the backend reports Google
// sign-in is configured. Clicking it is a full-page navigation that starts the
// OAuth flow on the API.
const GoogleButton = ({ label = 'Continue with Google' }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let active = true;
    authAPI.getProviders().then((r) => {
      if (active && r?.success) setEnabled(Boolean(r.data?.google));
    });
    return () => { active = false; };
  }, []);

  if (!enabled) return null;

  return (
    <div>
      <div className="relative my-5">
        <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-ink-200" /></div>
        <div className="relative flex justify-center">
          <span className="bg-white px-3 text-xs uppercase tracking-wider text-ink-400">or</span>
        </div>
      </div>
      <button
        type="button"
        onClick={() => { window.location.href = authAPI.googleStartUrl(); }}
        className="inline-flex w-full items-center justify-center gap-2.5 rounded-lg border border-ink-200 bg-white px-4 py-2.5 text-sm font-semibold text-ink-700 shadow-soft hover:bg-ink-50 transition"
      >
        <GoogleIcon /> {label}
      </button>
    </div>
  );
};

export default GoogleButton;
